import { isModuleNotFoundError } from '@tanstack/router-core';

import { buildId } from '@/lib/build-id';

// Per build, not per message: Safari's message names no chunk, and a new deploy earns a new reload.
const reloadKey = (): string => `coretas_stale_chunk:${buildId()}`;

// A deploy prunes old hashed chunks; storage that cannot record the reload never grants one.
export const reloadForStaleChunk = (error: unknown): boolean => {
  if (!(error instanceof Error) || !isModuleNotFoundError(error)) return false;
  try {
    if (sessionStorage.getItem(reloadKey())) return false;
    sessionStorage.setItem(reloadKey(), '1');
  } catch {
    return false;
  }
  window.location.reload();
  return true;
};
